import { BaseQueryFn } from '@reduxjs/toolkit/query';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { IAuth } from './auth/interface';
import { SOJI_USER } from './constants';

axios.interceptors.request.use(
  async (config) => {
    const result = localStorage.getItem(SOJI_USER);
    const token = result ? (JSON.parse(result) as IAuth).user?.token ?? '' : '';
    config.headers = {
      'x-auth-token': token,
      ...config.headers
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const axiosBaseQuery =
  ({
    baseUrl = '',
    baseHeaders = {}
  }: {
    baseUrl: string;
    baseHeaders?: AxiosRequestConfig['headers'];
  }): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig['method'];
      body?: AxiosRequestConfig['data'];
      headers?: AxiosRequestConfig['headers'];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, body, headers = {} }) => {
    try {
      const result = await axios({
        url: baseUrl + url,
        method,
        data: body,
        headers: { ...baseHeaders, ...headers }
      });
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError as AxiosError;
      return {
        error: { status: err.response?.status, ...err.response?.data }
      };
    }
  };
